// extracted by mini-css-extract-plugin
module.exports = {"menuBackground":"#545c64","loginBackground":"#737d96"};